module.exports = __webpack_public_path__ + "static/media/room.326a6c4e.png";